import Vue from 'vue'
import Router from 'vue-router'

import { authGuard } from './auth/authGuard'

import Start from './views/Start'
import Report from './views/Report'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'start',
      component: Start
    },
    {
      path: '/report/:id',
      name: 'report',
      component: Report
    },
    { // Redirect to start page in case of 404 error
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach(authGuard)

export default router
